export const isNullish = (val) => {
  return val === undefined || val === null
}

export const isNumber = (val) => {
  return typeof val === 'number'
}

export const debounce = (func, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func(...args)
    }, delay)
  }
}
